import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import { Link } from 'react-router-dom';

import { MAINTENANCE_SERVICE_ORDER_PATH } from '../../../../config/paths';

import MaintenanceChecklistBasicActivityButton from './MaintenanceChecklistBasicActivityButton';
import MaintenanceChecklistAdditionalActivityButton from './MaintenanceChecklistAdditionalActivityButton';
import MaintenanceChecklistAdditionalExecutionButton from './MaintenanceChecklistAdditionalExecutionButton';
import ChangeMaintenanceServiceOrderStatusButton from '../service-order/ChangeMaintenanceServiceOrderStatusButton';

const MaintenanceChecklistToolbar = ({
  serviceOrderId,
  serviceOrderStatus,
  maintenanceChecklist,
}) => {
  const checklistActivities =
    maintenanceChecklist.maintenanceChecklistActivityList || [];

  const hasBasicActivities = checklistActivities.some(
    (activity) => activity.basic === true,
  );

  const hasAdditionalActivities = checklistActivities.some(
    (activity) => activity.basic === false,
  );

  return (
    <ButtonToolbar className="pull-right">
      <div className="mr-2">
        <MaintenanceChecklistBasicActivityButton
          maintenanceChecklist={maintenanceChecklist}
          disabled={hasBasicActivities}
        />
      </div>

      <div className="mr-2">
        <MaintenanceChecklistAdditionalActivityButton
          maintenanceChecklist={maintenanceChecklist}
        />
      </div>

      <div className="mr-2">
        <MaintenanceChecklistAdditionalExecutionButton
          maintenanceChecklist={maintenanceChecklist}
          disabled={!hasAdditionalActivities}
        />
      </div>

      <div className="mr-2">
        <ChangeMaintenanceServiceOrderStatusButton
          maintenanceServiceOrderId={serviceOrderId}
          currentStatus={serviceOrderStatus}
          refreshServiceOrder={false}
        />
      </div>

      <div>
        <Link
          className="btn btn-primary"
          to={`${MAINTENANCE_SERVICE_ORDER_PATH}/${serviceOrderId}`}
          rel="noopener noreferrer"
        >
          <i className="fa fa-briefcase" /> Ver Orden de Servicio
        </Link>
      </div>
    </ButtonToolbar>
  );
};

MaintenanceChecklistToolbar.propTypes = {
  serviceOrderId: PropTypes.number.isRequired,
  serviceOrderStatus: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  maintenanceChecklist: PropTypes.object.isRequired,
};

MaintenanceChecklistToolbar.defaultProps = {
  serviceOrderStatus: null,
};

export default MaintenanceChecklistToolbar;
